import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { Image } from 'src/components/image';
import { NavigationButton } from 'src/components/navigation-button';
import { breakpointTablet } from 'src/styles/breakpoints';
import { colorBorder, colorNeutral } from 'src/styles/colors';
import { fontPrimary } from 'src/styles/fonts';
import { spacing0, spacing2, spacing3, spacing9 } from 'src/styles/spacing';

export const StyledCardContainer = styled.div`
  max-width: 364px;
`;

export const StyledCard = styled.div`
  border: 1px solid ${colorBorder};
  box-sizing: border-box;
  box-shadow: 0 4px 4px rgb(0 0 0 / 25%);
  border-radius: 2px;
  margin-bottom: ${spacing2};
  padding: ${spacing3} ${spacing2};
  min-height: 378px;
  background-color: ${colorNeutral};
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (min-width: ${breakpointTablet}) {
    min-height: 648px;
  }
`;

export const StyledImage = styled(Image)`
  display: none;

  @media (min-width: ${breakpointTablet}) {
    max-width: 170px;
    padding-bottom: ${spacing3};
    display: block;
    margin: 0 auto;
  }
`;

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  @media (min-width: ${breakpointTablet}) {
    min-height: 346px;
  }
`;

export const StyledTitle = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing2};
  text-align: center;
  font-family: ${fontPrimary};

  @media (min-width: ${breakpointTablet}) {
    margin-bottom: ${spacing3};
    padding: 0 ${spacing9};
  }
`;

export const StyledPrice = styled(Typography)`
  font-weight: bold;
  margin-bottom: ${spacing0};
`;

export const StyledPriceContainer = styled.div`
  margin: ${spacing3} 0;
  text-align: center;
`;

export const StyledNavigationButton = styled(NavigationButton)`
  margin: 0 auto;
`;
